import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createAddOnGroup, updateAddOnGroup, retireAddOnGroup, deleteAddOnGroup } from '../services/addonGroups';
import type { StoreAddOnGroupPayload } from '../services/addonGroup.types';
import { addonGroupKeys } from './useAddOnGroupsQuery';

export function useAddOnGroupMutations() {
    const queryClient = useQueryClient();
    const invalidate = () => queryClient.invalidateQueries({ queryKey: addonGroupKeys.all });

    return {
        createMutation: useMutation({
            mutationFn: (payload: StoreAddOnGroupPayload) => createAddOnGroup(payload),
            onSuccess: invalidate,
        }),
        updateMutation: useMutation({
            mutationFn: ({ id, payload }: { id: string; payload: Partial<StoreAddOnGroupPayload> }) => updateAddOnGroup(id, payload),
            onSuccess: invalidate,
        }),
        retireMutation: useMutation({
            mutationFn: (id: string) => retireAddOnGroup(id),
            onSuccess: invalidate,
        }),
        deleteMutation: useMutation({
            mutationFn: (id: string) => deleteAddOnGroup(id),
            onSuccess: invalidate,
        }),
    };
}
